export enum WordListLevel {
  onLevel = 'OnLevel',
  challenge = 'Challenge',
  emerging = 'Emerging',
}
